import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LaboratoryWaterSamplesService } from "../../../services/laboratory-water-samples.service";
import { LaboratoryWaterSampleDto } from "../../../models/laboratory/laboratory-water-sample.dto";

@Component({
    selector: 'laboratory-water-samples-additional',
    templateUrl: './laboratory-water-samples-additional.component.html',
    styleUrls: ['./laboratory-water-samples-additional.component.scss']
})
export class LaboratoryWaterSamplesAdditionalComponent implements OnInit {
    
    @Input() requestId: number;

    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();

    dataSaving: boolean;
    loading: boolean;

    samples: LaboratoryWaterSampleDto[] = [];

    constructor (
        private laboratoryWaterSamplesService: LaboratoryWaterSamplesService
    ) { }

    ngOnInit(): void {
        this.loading = true;
        this.laboratoryWaterSamplesService.getRequestWaterSamples(this.requestId).subscribe(resp => {
            this.samples = resp;
            this.loading = false;
        });
    }

    saveChanges() {
        this.dataSaving = true;
        this.laboratoryWaterSamplesService.multipleUpdate(this.samples).subscribe(() => {
            this.onContinueEvent.emit();
            this.dataSaving = false;
        });
    }

    cancel() {
        this.onCancelEvent.emit();
    }
}